import { useDispatch } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';

import { TAnswersState } from '../../FormContainer/types/internal';
import { isSpecialistsAvailable } from '../../../actions/isSpecialistsAvailable';
import { getGeoMapper } from '../../../utils/getGeoMapper';
import { EDealTypeEx } from '../../../repositories/demand/entities/public_v5_create_message/RequestMessageV5Schema';
import { TThunkDispatch } from '../../../types/redux';

export const useAvailableRealtorChoice = (answersState: TAnswersState) => {
  const dispatch = useDispatch<TThunkDispatch>();
  const [isAvailableChoice, setIsAvailableChoice] = useState<null | boolean>(null);

  const checkIsAvailable = useCallback(async () => {
    if (!answersState.address) {
      return false;
    }

    const geoMapper = getGeoMapper(answersState.dealTypeEx?.value as EDealTypeEx);
    const geo = geoMapper(answersState.address);
    const isAvailable = await dispatch(isSpecialistsAvailable({ ...geo }));

    return isAvailable;
  }, [answersState.address, dispatch]);

  useEffect(() => {
    let isMounted = true;

    (async () => {
      const isAvailable = await checkIsAvailable();
      if (isMounted) {
        setIsAvailableChoice(isAvailable);
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [checkIsAvailable]);

  const isFetching = isAvailableChoice === null;

  return { isAvailableChoice, isFetching };
};
